/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeleteGmsBatch200ResponseAffectedTablesInner } from './DeleteGmsBatch200ResponseAffectedTablesInner';
import {
    DeleteGmsBatch200ResponseAffectedTablesInnerFromJSON,
    DeleteGmsBatch200ResponseAffectedTablesInnerFromJSONTyped,
    DeleteGmsBatch200ResponseAffectedTablesInnerToJSON,
    DeleteGmsBatch200ResponseAffectedTablesInnerToJSONTyped,
} from './DeleteGmsBatch200ResponseAffectedTablesInner';

/**
 * 
 * @export
 * @interface DeleteGmsBatch200Response
 */
export interface DeleteGmsBatch200Response {
    /**
     * 処理結果のリスト
     * @type {Array<DeleteGmsBatch200ResponseAffectedTablesInner>}
     * @memberof DeleteGmsBatch200Response
     */
    affectedTables: Array<DeleteGmsBatch200ResponseAffectedTablesInner>;
}

/**
 * Check if a given object implements the DeleteGmsBatch200Response interface.
 */
export function instanceOfDeleteGmsBatch200Response(value: object): value is DeleteGmsBatch200Response {
    if (!('affectedTables' in value) || value['affectedTables'] === undefined) return false;
    return true;
}

export function DeleteGmsBatch200ResponseFromJSON(json: any): DeleteGmsBatch200Response {
    return DeleteGmsBatch200ResponseFromJSONTyped(json, false);
}

export function DeleteGmsBatch200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteGmsBatch200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'affectedTables': ((json['affected_tables'] as Array<any>).map(DeleteGmsBatch200ResponseAffectedTablesInnerFromJSON)),
    };
}

export function DeleteGmsBatch200ResponseToJSON(json: any): DeleteGmsBatch200Response {
    return DeleteGmsBatch200ResponseToJSONTyped(json, false);
}

export function DeleteGmsBatch200ResponseToJSONTyped(value?: DeleteGmsBatch200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'affected_tables': ((value['affectedTables'] as Array<any>).map(DeleteGmsBatch200ResponseAffectedTablesInnerToJSON)),
    };
}

